// import { Box, Grid, Typography, Paper, Avatar, Button } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import { getDefaultMenu } from './../../../../services/api/MenuAPI';
// import GetQuotationForm from './GetQuotationForm';

// const MenuCard = ({
// 	data,
// 	handleOpen,
// }: {
// 	data: any;
// 	handleOpen: (defaultMenuId: string) => void;
// }) => (
// 	<div>
// 		<Box
// 			sx={{
// 				borderTopLeftRadius: 5,
// 				borderTopRightRadius: 5,
// 				backgroundColor: 'primary.main',
// 				p: 0,
// 				pt: 3,
// 				pb: 2,
// 			}}
// 		>
// 			<Typography variant="h6" align="center" fontWeight="bold" color="#fff">
// 				{data.name}
// 			</Typography>
// 			<Typography variant="h5" align="center" fontWeight={600} gutterBottom color="#FFFFFF">
// 				₹{data.price.toLocaleString()}
// 			</Typography>
// 			<Typography variant="subtitle2" color="secondary" align="center" fontWeight={600}>
// 				{data.description}
// 			</Typography>
// 		</Box>
// 		<Paper
// 			elevation={3}
// 			sx={{
// 				borderRadius: 0,
// 				borderBottomLeftRadius: 5,
// 				borderBottomRightRadius: 5,
// 				p: 3,
// 				mb: 4,
// 			}}
// 		>
// 			{data.menuItems?.map((menuItem: any, i: number) => (
// 				<Box key={i} sx={{ mb: 2 }}>
// 					<Typography variant="subtitle1" fontWeight="bold" color="error" gutterBottom>
// 						{menuItem.menuType} For {menuItem.numberOfPersons} Person
// 					</Typography>

// 					{menuItem.items?.map((item: string, j: number) => (
// 						<Box key={j} display="flex" alignItems="flex-start" gap={1} mb={0.5}>
// 							<Avatar
// 								src={'/assets/points-image.svg'}
// 								alt="bullet"
// 								sx={{ width: 22, height: 15 }}
// 							/>
// 							<Typography variant="body2">{item}</Typography>
// 						</Box>
// 					))}
// 				</Box>
// 			))}
// 			<Box sx={{ mb: 2 }}>
// 				<Typography variant="subtitle1" fontWeight="bold" color="error" gutterBottom>
// 					Complementary
// 				</Typography>
// 				<Box display="flex" alignItems="flex-start" gap={1} mb={0.5}>
// 					<Avatar
// 						src={'/assets/points-image.svg'}
// 						alt="bullet"
// 						sx={{ width: 22, height: 15, marginTop: '5px' }}
// 					/>
// 					<Typography variant="body2">{data.complementary}</Typography>
// 				</Box>
// 			</Box>
// 			<Box
// 				display={'flex'}
// 				justifyContent={'space-around'}
// 				alignItems={'center'}
// 				sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
// 			>
// 				{data.menuImage?.map((menuImage: any, i: number) => (
// 					<Box key={i}>
// 						<Avatar
// 							src={menuImage}
// 							style={{ borderRadius: 2, width: '85px', height: '85px' }}
// 							variant="square"
// 						></Avatar>
// 					</Box>
// 				))}
// 			</Box>

// 			<Box className="mt-4 d-flex justify-content-center align-item-center">
// 				<Button color="primary" variant="contained" onClick={() => handleOpen(data._id)}>
// 					Select this package
// 				</Button>
// 			</Box>
// 		</Paper>
// 	</div>
// );

// const MenuContainer2 = () => {
// 	const [menus, setMenus] = useState<any[]>([]);
// 	const [formOpen, setFormOpen] = useState(false);
// 	const [selectedMenuId, setSelectedMenu] = useState('');

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const response = await getDefaultMenu();
// 				if (response?.success) {
// 					setMenus(response.data.menus);
// 				}
// 			} catch (error) {
// 				console.error('Error fetching menu:', error);
// 			}
// 		};
// 		fetchData();
// 	}, []);

// 	const handleClose = () => setFormOpen(false);
// 	const handleOpen = (defaultMenuId: string) => {
// 		setFormOpen(true);
// 		setSelectedMenu(defaultMenuId);
// 	};
// 	return (
// 		<Box padding={2}>
// 			<Box textAlign="center" padding={3}>
// 				<Typography variant="h4" color="primary" gutterBottom>
// 					Classic Wedding Catering Packages
// 				</Typography>
// 				<Typography variant="h6" gutterBottom>
// 					Celebrate your special day with our thoughtfully curated wedding menu packages.
// 					Delicious dishes, elegant presentation, and seamless service — all at
// 					transparent prices to suit every budget.
// 				</Typography>
// 			</Box>

// 			<Grid container spacing={4} justifyContent="center">
// 				{menus.map((menu, index) => (
// 					<Grid size={{ xs: 12, md: 6 }} key={index}>
// 						<MenuCard data={menu} handleOpen={handleOpen} />
// 					</Grid>
// 				))}
// 			</Grid>
// 			<GetQuotationForm
// 				open={formOpen}
// 				handleClose={handleClose}
// 				defaultMenuId={selectedMenuId}
// 			/>
// 		</Box>
// 	);
// };

// export default MenuContainer2;
// =====================================================================================================================
// =====================================================================================================================
// =====================================================================================================================
// =====================================================================================================================
// import React, { useEffect, useState } from 'react';
// import { Box, Grid, Typography } from '@mui/material';
// import { getDefaultMenu } from './../../../../services/api/MenuAPI';
// import GetQuotationForm from './GetQuotationForm';
// import MenuCard from './MenuCard';

// const MenuContainer2: React.FC = () => {
// 	const [menus, setMenus] = useState<any[]>([]);
// 	const [formOpen, setFormOpen] = useState(false);
// 	const [selectedMenuId, setSelectedMenu] = useState('');
// 	const [selectedEvent, setSelectedEvent] = useState('');

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const response = await getDefaultMenu();
// 				if (response?.success) {
// 					setMenus(response.data.menus);
// 				}
// 			} catch (error) {
// 				console.error('Error fetching menu:', error);
// 			}
// 		};
// 		fetchData();
// 	}, []);

// 	const handleClose = () => setFormOpen(false);

// 	const handleOpen = (defaultMenuId: string, eventID: string) => {
// 		setFormOpen(true);
// 		setSelectedMenu(defaultMenuId);
// 		setSelectedEvent(eventID);
// 	};

// 	return (
// 		<Box padding={2}>
// 			<Box textAlign="center" padding={3}>
// 				<Typography variant="h4" color="primary" gutterBottom>
// 					Classic Wedding Catering Packages
// 				</Typography>
// 				<Typography variant="h6" gutterBottom>
// 					Celebrate your special day with our thoughtfully curated wedding menu packages.
// 					Delicious dishes, elegant presentation, and seamless service — all at
// 					transparent prices to suit every budget.
// 				</Typography>
// 			</Box>

// 			<Grid container spacing={4} justifyContent="center">
// 				{menus.map((menu, index) => (
// 					<Grid size={{ xs: 12, md: 6 }} key={index}>
// 						<MenuCard data={menu} handleOpen={handleOpen} />
// 					</Grid>
// 				))}
// 			</Grid>

// 			<GetQuotationForm
// 				open={formOpen}
// 				handleClose={handleClose}
// 				defaultMenuId={selectedMenuId}
// 				eventID={selectedEvent}
// 			/>
// 		</Box>
// 	);
// };

// export default MenuContainer2;
// =====================================================================================================================
// =====================================================================================================================
// =====================================================================================================================
// =====================================================================================================================
import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { styled } from '@mui/material/styles';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../../components/common/page/Homepage/FestivalSlider/Slideshow.css';
import { getDefaultMenu } from './../../../../services/api/MenuAPI';
import GetQuotationForm from './GetQuotationForm';
import MenuCard from './MenuCard';
import './DefaultMenuCard.css';

const Slide = styled(Box)(() => ({
	width: '100%',
	position: 'relative',
	overflow: 'hidden',
}));

const MenuContainer2: React.FC = () => {
	const [menus, setMenus] = useState<any[]>([]);
	const [formOpen, setFormOpen] = useState(false);
	const [selectedMenuId, setSelectedMenu] = useState('');
	const [selectedEvent, setSelectedEvent] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await getDefaultMenu();
				if (response?.success) {
					setMenus(response.data.menus);
				}
			} catch (error) {
				console.error('Error fetching menu:', error);
			}
		};
		fetchData();
	}, []);

	const handleClose = () => setFormOpen(false);

	const handleOpen = (defaultMenuId: string, eventID: string) => {
		setFormOpen(true);
		setSelectedMenu(defaultMenuId);
		setSelectedEvent(eventID);
	};

	return (
		<Box padding={2}>
			<Box textAlign="center" padding={3}>
				<Typography variant="h4" color="primary" gutterBottom>
					Classic Wedding Catering Packages
				</Typography>
				<Typography variant="h6" gutterBottom>
					Celebrate your special day with our thoughtfully curated wedding menu packages.
					Delicious dishes, elegant presentation, and seamless service — all at
					transparent prices to suit every budget.
				</Typography>
			</Box>

			<Grid container justifyContent="center">
				<Grid size={{ xs: 12, md: 10 }}>
					<Swiper
						spaceBetween={30}
						slidesPerView={1}
						autoplay={{
							delay: 2500,
							disableOnInteraction: false,
							pauseOnMouseEnter: true,
						}}
						pagination={{
							clickable: true,
						}}
						navigation={true}
						modules={[Autoplay, Pagination, Navigation]}
						className="mySwiper"
						breakpoints={{
							600: {
								slidesPerView: 1,
							},
							900: {
								slidesPerView: 2,
							},
							1200: {
								slidesPerView: 3,
							},
						}}
					>
						{menus.map((menu, index) => (
							<SwiperSlide key={index}>
								<Slide>
									<MenuCard data={menu} handleOpen={handleOpen} />
								</Slide>
							</SwiperSlide>
						))}
					</Swiper>
				</Grid>
			</Grid>

			<GetQuotationForm
				open={formOpen}
				handleClose={handleClose}
				defaultMenuId={selectedMenuId}
				eventID={selectedEvent}
			/>
		</Box>
	);
};

export default MenuContainer2;
